import { EApiLanguages, TBrand } from "@cakemail-org/ui-components-v2"
import { TDropMenuItem } from "@cakemail-org/ui-components-v2/dist/esm/components/dropMenu/types"
import { t } from "i18next"

export function supportedLocales() {
    return [
        {
            text: t("general-languages_en-US"),
            value: "en_US",
            supportLink: "en-us",
        },
        {
            text: t("general-languages_fr-CA"),
            value: "fr_CA",
            supportLink: "fr",
        },
        {
            text: t("general-languages_nl-NL"),
            value: "nl_NL",
            supportLink: "nl-nl",
        },
        {
            text: t("general-languages_es-ES"),
            value: "es_ES",
            supportLink: "es-es",
        },
        {
            text: t("general-languages_pt-BR"),
            value: "pt_BR",
            supportLink: "pt-br",
        },
        {
            text: t("general-languages_es-US"),
            value: "es_US",
            supportLink: "es-us",
        },
        {
            text: t("general-languages_fi"),
            value: "fi",
            supportLink: "fi",
        },
        {
            text: t("general-languages_sv"),
            value: "sv",
            alternative: "sv_SE",
            supportLink: "sv",
        },
        {
            text: t("general-languages_it"),
            value: 'it',
            supportLink: "it",
        },
        {
            text: t("general-languages_el-GR"),
            value: 'el_GR',
            supportLink: "el-GR",
        },
    ]
}


function getLanguages({ languageList = undefined, partnerBrand, simpleArray }: { languageList?: string[], partnerBrand?: TBrand, simpleArray?: boolean } = {}): { text: any, value: string, supportLink?: string, alternative?: string }[] {
    const defaultLocals = ["en_us", "fr_ca"]
    let resellerLocales = languageList || partnerBrand?.client_config?.languages || []
    let localesToUse = []

    if (resellerLocales && resellerLocales.length > 0) {
        resellerLocales = resellerLocales.map((locale: string) => locale.toLowerCase())
        localesToUse = supportedLocales().filter((locale) => {
            return resellerLocales.includes(locale.value.toLowerCase())
        })
    } else {
        localesToUse = supportedLocales().filter((locale) => {
            return defaultLocals.includes(locale.value.toLowerCase())
        })
    }
    return localesToUse
}


export function getSimpleLanguagesValues(partnerBrand?: TBrand, prefixToAdd: string = "", toLowerCase?: boolean): string[] {
    return getLanguages({ partnerBrand })?.map((l) => {
        return formatLang({ lang: l, prefixToAdd, toLowerCase }).value || ""
    }) || []
}

export function getLanguagesOptions({ partnerBrand, prefixToAdd, toLowerCase, useApiLanguages }: { partnerBrand?: TBrand, prefixToAdd?: string, toLowerCase?: boolean, useApiLanguages?: boolean }): TDropMenuItem[] {
    if (useApiLanguages) {
        return Object.values(EApiLanguages).map((l) => {
            return formatLang({ lang: { value: l }, prefixToAdd, toLowerCase })
        })
    }

    return getLanguages({ partnerBrand }).map((language, index) => {
        return formatLang({ lang: language, prefixToAdd, toLowerCase })
    })
}

function formatLang({ lang, prefixToAdd, toLowerCase }: { lang: TDropMenuItem, prefixToAdd?: string, toLowerCase?: boolean }) {
    let value = lang.value
    if (value && toLowerCase)
        value = value.toLocaleLowerCase()

    return {
        text: lang.text || t("general-languages_" + lang.value?.replace("_", "-")),
        value: prefixToAdd ? prefixToAdd + value : value
    }
}

export function getLanguageUrlSegment(userLanguage: string, partnerBrand?: TBrand): string {
    const userLangLower = userLanguage.toLowerCase()

    //currently the url language url segment paths in docs,cakemail.com are not yet standardized to our naming conventions.
    
    // Switch case to map locale codes to URL segments
    // Only 3 supported URL segments: en, fr, es
    switch (userLangLower) {
        // English variants
        case 'en_us':
        case 'en_ca':
            return 'en'
        
        case 'fr_ca':
            return 'fr-ca'
        case 'fr_fr':
            return 'fr'
        case 'fr_qc':
            return 'fr-qc'
        
        // Spanish variants (all map to 'es') 
        case 'es_es':
        case 'es_us':
            return 'es'
        
        // All other languages fallback to English until further language support is added in docs
        case 'el_gr':
        case 'fi':
        case 'fil_ph':
        case 'it':
        case 'nl_nl':
        case 'pt_br':
        case 'sv':
        case 'sv_se':
        default:
            return 'en'
    }
}